/**
 * The business-onboarding wizard's framework-free core, shared by the mobile
 * app, the web wizard and the api.
 *
 * Everything here is pure: no React, no storage, no Prisma. That is what lets
 * one definition of "what a chapter owes" and "what a draft looks like" serve
 * three consumers instead of drifting into three.
 */
export * from './types.js';
export * from './hours.js';
export * from './chapters.js';
export * from './draft.js';
